import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Импортируем все баннеры
import banner1 from "../../assets/banners/packagebannerarm.png";
import bannereng1 from "../../assets/banners/packagebannereng.png";
import bannerru1 from "../../assets/banners/packagebannerru.png";

import banner2 from "../../assets/banners/seetopbannerarm.png";
import bannereng2 from "../../assets/banners/seetopbannereng.png";
import bannerru2 from "../../assets/banners/seetopbannerru.png";

const EmployerBannersProfile = () => {
  const { t } = useTranslation();

  // Выбираем баннеры в зависимости от языка
  let bannerA = banner1;
  let bannerB = banner2;

  if (t.language === "ru") {
    bannerA = bannerru1;
    bannerB = bannerru2;
  } else if (t.language === "en") {
    bannerA = bannereng1;
    bannerB = bannereng2;
  }

  return (
    <section className="w-full p-[20px] max-lg:p-2 max-xl:flex-col gap-6 max-md:gap-3 flex justify-between items-center">
      <Link to='/Top_Candidates' className="w-full h-[290px] max-sm:h-[140px] max-sm:rounded-xl max-md:h-[250px] max-lg:h-[180px] max-xl:h-[250px] max-2xl:h-[200px] transition-all duration-200 hover:shadow-[0_0_40px_#0066748e] rounded-[40px] relative overflow-hidden group">
        <div className="absolute opacity-0 transition-all duration-200 shadow-[inset_0_0_80px_black] group-hover:opacity-20 inset-0 size-full bg-[#006674]"></div>
        <img className="size-full object-cover" src={bannerB} alt="banner2" />
      </Link>
       <Link to="/PricingPage" className="w-full h-[290px] max-sm:h-[140px] max-md:h-[250px] max-sm:rounded-xl max-lg:h-[180px] max-xl:h-[250px] max-2xl:h-[200px] transition-all duration-200 hover:shadow-[0_0_40px_#0066748e] rounded-[40px] relative overflow-hidden group">
        <div className="absolute opacity-0 transition-all duration-200 shadow-[inset_0_0_80px_black] group-hover:opacity-20 inset-0 size-full bg-[#006674]"></div>
        <img className="size-full object-cover" src={bannerA} alt="banner1" />
      </Link>
    </section>
  );
};

export default EmployerBannersProfile;
